/* Amora Silk — 22 Momme product page */
(() => {
  const root = document.querySelector('[data-ap-root]');
  if (!root || root.dataset.ready) return;
  root.dataset.ready = '1';

  const product = JSON.parse(root.querySelector('[data-ap-product]').textContent);
  const base = root.dataset.assetBase || '';
  const currency = root.dataset.currency || 'USD';
  const money = new Intl.NumberFormat('en-US', { style: 'currency', currency });
  const fmt = (cents) => money.format(cents / 100);
  const $ = (sel, el = root) => el.querySelector(sel);

  const COLOURS = {
    'black': ['#232323', 'black'], 'champagne': ['#c9ad90', 'champagne'], 'dark blue': ['#22334d', 'dark-blue'],
    'dark gray': ['#5f5d64', 'dark-gray'], 'dark grey': ['#5f5d64', 'dark-gray'], 'light pink': ['#ecc9c3', 'light-pink'],
    'silver gray': ['#b9b8bf', 'silver-gray'], 'silver grey': ['#b9b8bf', 'silver-gray'], 'white': ['#f7f2ea', 'white'],
    'smoky pink': ['#bd8f96', 'smoky-pink']
  };
  const colourInfo = (name) => COLOURS[String(name).toLowerCase()] || ['#c9ad90', 'champagne'];
  const sizeName = (value) => /66/.test(value) ? 'Standard' : /76/.test(value) ? 'Queen' : /91/.test(value) ? 'King' : value;
  const isZip = (value) => /zip|rits/i.test(value);
  const img = (file) => base + file;
  /* Lighter images: Shopify serves resized theme images; fall back to the original if needed */
  const sample = root.dataset.assetSized || '';
  const style = /_900x\./.test(sample) ? 'suffix' : /[?&]width=900/.test(sample) ? 'param' : '';
  const unsize = (url) => url.replace(/_\d+x(\.(?:jpe?g|png|webp))/i, '$1').replace(/([?&])width=\d+&?/, '$1').replace(/[?&]$/, '');
  const resize = (url, w) => { const u = unsize(url); return style === 'suffix' ? u.replace(/(\.(?:jpe?g|png|webp))(\?|$)/i, `_${w}x$1$2`)
    : style === 'param' ? u + (u.includes('?') ? '&' : '?') + 'width=' + w : u; };
  const sz = (file, w = 900) => resize(img(file), w);
  const fix = (t) => {
    if (!t || t.tagName !== 'IMG' || t.dataset.fallback) return;
    const full = unsize(t.currentSrc || t.src);
    if (full && full !== t.src) { t.dataset.fallback = '1'; t.removeAttribute('srcset'); t.src = full; }
  };
  root.addEventListener('error', (e) => fix(e.target), true);
  root.querySelectorAll('img').forEach((t) => { if (t.complete && t.src && !t.naturalWidth) fix(t); });
  const ratingText = (root.querySelector('.ap-rating strong') || {}).textContent || '4.9';
  if (!document.querySelector('link[data-ap-slides-css]')) {
    const link = document.createElement('link');
    link.rel = 'stylesheet'; link.href = img('amora-22-slides.css'); link.setAttribute('data-ap-slides-css', '');
    document.head.appendChild(link);
  }

  const optionIndex = (patterns) => Math.max(0, product.options.findIndex((o) => patterns.test(String(o.name || o))));
  const iColour = optionIndex(/colou?r|kleur/i);
  const iSize = optionIndex(/size|maat/i);
  const iClosure = optionIndex(/closure|sluiting/i);
  const values = (i) => [...new Set(product.variants.map((v) => v.options[i]))];
  const colours = values(iColour), sizes = values(iSize), closures = values(iClosure);

  const BUNDLES = [
    { n: 1, rate: 1, title: '1 Pillowcase', note: 'Try silk' },
    { n: 2, rate: 0.85, title: '2 Pillowcases', note: 'One for you, one to share', tag: 'Most popular' },
    { n: 4, rate: 0.75, title: '4 Pillowcases', note: 'Every pillow, all week', tag: 'Best value', dark: true }
  ];

  const params = new URLSearchParams(location.search);
  const start = product.variants.find((v) => String(v.id) === params.get('variant')) || product.variants.find((v) => v.available && /champagne/i.test(v.options.join(' '))) || product.variants.find((v) => v.available) || product.variants[0];
  const state = { colour: start.options[iColour], size: start.options[iSize], closure: start.options[iClosure], n: 1, pieces: [], open: new Set() };

  const find = (colour, size = state.size, closure = state.closure) => product.variants.find((v) => v.options[iColour] === colour && v.options[iSize] === size && v.options[iClosure] === closure);
  const current = () => find(state.colour);
  const bundle = () => BUNDLES.find((b) => b.n === state.n);
  const unit = (variant, rate) => Math.ceil(variant.price * rate);
  const mainChoice = () => ({ colour: state.colour, size: state.size, closure: state.closure });
  const syncPieces = (reset) => {
    if (reset) state.pieces = [];
    state.pieces = Array.from({ length: state.n }, (_, i) => state.pieces[i] || mainChoice());
  };
  const pieceVariant = (p) => find(p.colour, p.size, p.closure);
  const closureName = (c) => isZip(c) ? 'Zipper' : 'Envelope';

  /* ---------- Gallery ---------- */
  const track = $('[data-ap-track]'), dots = $('[data-ap-dots]'), thumbs = $('[data-ap-thumbs]');
  let shownKey = null;
  function renderGallery() {
    const key = colourInfo(state.colour)[1];
    const detail = isZip(state.closure) ? 'zipper' : 'closure';
    const signature = key + detail;
    if (shownKey === signature) return;
    shownKey = signature;
    const ICONS = {
      hair: '<path d="M10 3C0 15 20 17 9 29M17 3C7 15 27 17 16 29M24 3C14 15 34 17 23 29"/>',
      face: '<path d="M16 4c-6 0-10 5-10 11 0 7 4 13 10 13s10-6 10-13c0-6-4-11-10-11Z"/><path d="M12 14h.01M20 14h.01M12.5 20.5c2 1.8 5 1.8 7 0"/>',
      drop: '<path d="M16 3s-8 10-8 16a8 8 0 0 0 16 0c0-6-8-16-8-16Z"/><path d="M12.5 20a3.5 3.5 0 0 0 3.5 3.5"/>',
      moon: '<path d="M27 21A13 13 0 0 1 11 5a13 13 0 1 0 16 16Z"/>'
    };
    const icon = (n) => `<svg viewBox="0 0 32 32" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">${ICONS[n]}</svg>`;
    const hero = sz(`amora-gallery-${key}-hero-v2.jpg`), tex = sz(`amora-gallery-${key}-texture-v2.jpg`);
    const why = [['hair', 'Smoother hair', 'Less frizz, tangles &amp; bed-head'], ['face', 'Fewer sleep creases', 'Gentle, low-friction surface'], ['drop', 'Skincare stays put', 'Absorbs less night cream'], ['moon', 'Cool, deep sleep', 'Breathable, temperature-friendly']];
    const li = (cls, t) => `<li class="${cls}">${t}</li>`;
    const slides = [
      { thumb: img(`amora-gallery-${key}-single-v2.jpg`), html: `<img src="${sz(`amora-gallery-${key}-single-v2.jpg`)}" alt="${product.title} in ${state.colour}" width="1254" height="1254" fetchpriority="high">` },
      { thumb: hero, html: `<div class="ap-sl ap-sl--stack"><p class="top">100% Mulberry Silk · 22 Momme</p><img class="fg" src="${hero}" alt="Stacked ${state.colour} silk pillowcases" loading="lazy"><p class="bot"><span>8 colours</span><span>3 sizes</span><span>2 closures</span></p></div>` },
      { thumb: tex, html: `<div class="ap-sl ap-sl--why"><img class="tex" src="${tex}" alt="" loading="lazy"><span class="tag">100% Mulberry Silk · 22 Momme</span><div class="panel"><p class="eb">Why you'll love it</p><h2 class="sf">Beauty sleep, made real</h2><div class="grid">${why.map(([i, t, d]) => `<div class="b"><span class="i">${icon(i)}</span><div><h3 class="sf">${t}</h3><p>${d}</p></div></div>`).join('')}</div></div></div>` },
      { thumb: img(`amora-gallery-${key}-${detail}-v2.jpg`), html: `<img src="${sz(`amora-gallery-${key}-${detail}-v2.jpg`)}" alt="${detail === 'zipper' ? 'Zipper' : 'Envelope'} closure in ${state.colour}" width="1254" height="1254" loading="lazy">` },
      { thumb: tex, html: `<div class="ap-sl ap-sl--vs"><div class="head"><p class="eb">The difference</p><h2 class="sf">Silk vs. cotton</h2></div><div class="cols"><div class="col c"><img src="${sz('amora-cotton-texture-v51.jpg')}" alt="Cotton fabric" loading="lazy"><div class="card"><h3 class="sf">Cotton</h3><ul>${li('n', 'Frizzy hair')}${li('n', 'Sleep creases')}${li('n', 'Soaks up skincare')}</ul></div></div><div class="col k"><img src="${tex}" alt="${state.colour} mulberry silk" loading="lazy"><div class="card"><h3 class="sf">Amora Silk</h3><ul>${li('y', 'Smooth hair')}${li('y', 'Gentle on skin')}${li('y', 'Skincare stays on')}</ul></div></div></div></div>` },
      { thumb: img('amora-hero.jpg'), html: `<div class="ap-sl ap-sl--rev"><img class="bg" src="${sz('amora-hero.jpg')}" alt="Woman sleeping on a silk pillowcase" loading="lazy"><div class="shade"></div><div class="card"><div class="stars" aria-hidden="true">★★★★★</div><p class="score"><b>${ratingText}</b> out of 5 · loved by our customers</p><p class="q sf">“I’ve been using satin for years, and silk is definitely the better choice. My hair and skin feel amazing.”</p><p class="who">Wendy</p></div></div>` }
    ];
    track.innerHTML = slides.map((s) => `<figure class="ap-gallery__slide">${s.html}</figure>`).join('');
    dots.innerHTML = slides.map((_, i) => `<span class="${i ? '' : 'is-active'}"></span>`).join('');
    thumbs.innerHTML = slides.map((s, i) => `<button type="button" aria-label="Show photo ${i + 1}" aria-current="${i === 0}"><img src="${resize(s.thumb, 200)}" alt="" loading="lazy" width="160" height="160"></button>`).join('');
    track.scrollTo({ left: 0 });
  }
  track.addEventListener('scroll', () => {
    const i = Math.round(track.scrollLeft / track.clientWidth);
    dots.querySelectorAll('span').forEach((d, j) => d.classList.toggle('is-active', i === j));
    const badge = $('.ap-gallery__badge');
    if (badge) { badge.style.transition = 'opacity .2s'; badge.style.opacity = i === 0 ? '1' : '0'; }
    thumbs.querySelectorAll('button').forEach((b, j) => b.setAttribute('aria-current', String(i === j)));
  }, { passive: true });
  thumbs.addEventListener('click', (e) => {
    const b = e.target.closest('button'); if (!b) return;
    const i = [...thumbs.children].indexOf(b);
    track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' });
  });

  /* ---------- Options ---------- */
  function renderOptions() {
    const v = current();
    $('[data-ap-colour-name]').textContent = state.colour;
    $('[data-ap-size-name]').textContent = sizeName(state.size);
    $('[data-ap-closure-name]').textContent = isZip(state.closure) ? 'Zipper' : 'Envelope';

    $('[data-ap-colours]').innerHTML = colours.map((c) => {
      const ok = !!(find(c) && find(c).available);
      return `<button type="button" class="ap-swatch" data-colour="${c}" style="--c:${colourInfo(c)[0]}" title="${c}" aria-label="${c}" aria-checked="${c === state.colour}" role="radio" ${ok ? '' : 'disabled'}></button>`;
    }).join('');

    $('[data-ap-sizes]').innerHTML = sizes.map((s) => {
      const ok = !!(find(state.colour, s) && find(state.colour, s).available);
      return `<button type="button" class="ap-size" data-size="${s}" role="radio" aria-checked="${s === state.size}" ${ok ? '' : 'disabled'}><strong>${sizeName(s)}</strong><small>${s.replace(/ x /, ' × ')}</small></button>`;
    }).join('');

    const key = colourInfo(state.colour)[1];
    $('[data-ap-closures]').innerHTML = closures.map((c) => {
      const zip = isZip(c);
      const ok = !!(find(state.colour, state.size, c) && find(state.colour, state.size, c).available);
      return `<button type="button" class="ap-closure" data-closure="${c}" role="radio" aria-checked="${c === state.closure}" ${ok ? '' : 'disabled'}><img src="${sz(`amora-gallery-${key}-${zip ? 'zipper' : 'closure'}-v2.jpg`, 200)}" alt="" width="46" height="46" loading="lazy"><span><strong>${zip ? 'Zipper' : 'Envelope'}</strong><small>${zip ? 'Zips closed, stays put' : 'No zip, slips on easily'}</small></span></button>`;
    }).join('');

    $('[data-ap-bundles]').innerHTML = BUNDLES.map((b) => {
      const each = unit(v, b.rate), total = each * b.n, regular = v.price * b.n;
      const off = b.rate < 1 ? `<span class="ap-bundle-card__off">Save ${Math.round((1 - b.rate) * 100)}%</span>` : '';
      return `<button type="button" class="ap-bundle-card" data-n="${b.n}" role="radio" aria-checked="${b.n === state.n}">
        ${b.tag ? `<span class="ap-bundle-card__tag ${b.dark ? 'ap-bundle-card__tag--dark' : ''}">${b.tag}</span>` : ''}
        <span class="ap-bundle-card__radio" aria-hidden="true"></span>
        <span><strong>${b.title}${off}</strong><small>${b.n > 1 ? `${fmt(each)} each · ${b.note}` : b.note}</small></span>
        <span class="ap-bundle-card__price"><b>${fmt(total)}</b>${b.rate < 1 ? `<s>${fmt(regular)}</s>` : ''}</span>
      </button>`;
    }).join('');

    renderPieces();
    renderPrice();
    renderGallery();
  }

  function piecesBox() {
    let box = $('[data-ap-pieces]');
    if (!box) {
      box = document.createElement('div');
      box.className = 'ap-pieces'; box.setAttribute('data-ap-pieces', ''); box.hidden = true;
      $('[data-ap-bundles]').after(box);
    }
    if (!document.querySelector('link[data-ap-pieces-css]')) {
      const link = document.createElement('link');
      link.rel = 'stylesheet'; link.href = img('amora-22-pieces.css'); link.setAttribute('data-ap-pieces-css', '');
      document.head.appendChild(link);
    }
    return box;
  }

  function renderPieces() {
    const box = piecesBox();
    if (state.n === 1) { box.hidden = true; box.innerHTML = ''; return; }
    box.hidden = false;
    const ok = (p) => { const v = pieceVariant(p); return !!(v && v.available); };
    box.innerHTML = `<p class="ap-pieces__title">Customise each pillowcase</p>` + state.pieces.map((p, i) => `
      <details class="ap-piece" data-piece-card="${i}" ${state.open.has(i) ? 'open' : ''}>
        <summary>
          <span class="ap-piece__dot" style="--c:${colourInfo(p.colour)[0]}" aria-hidden="true"></span>
          <span><strong>Pillowcase ${i + 1}</strong><small>${p.colour} · ${sizeName(p.size)} · ${closureName(p.closure)}</small></span>
          <span class="ap-piece__edit">${state.open.has(i) ? 'Done' : 'Edit'}</span>
        </summary>
        <div class="ap-piece__body">
          <div><p class="ap-piece__label">Colour: <strong>${p.colour}</strong></p><div class="ap-swatches">${colours.map((c) => `<button type="button" class="ap-swatch" data-piece="${i}" data-piece-colour="${c}" style="--c:${colourInfo(c)[0]}" aria-label="Pillowcase ${i + 1}: ${c}" title="${c}" role="radio" aria-checked="${c === p.colour}" ${ok({ ...p, colour: c }) ? '' : 'disabled'}></button>`).join('')}</div></div>
          <div><p class="ap-piece__label">Size: <strong>${sizeName(p.size)}</strong></p><div class="ap-piece__opts">${sizes.map((z) => `<button type="button" class="ap-piece__opt" data-piece="${i}" data-piece-size="${z}" role="radio" aria-checked="${z === p.size}" ${ok({ ...p, size: z }) ? '' : 'disabled'}>${sizeName(z)}<small>${z.replace(/ x /, ' × ')}</small></button>`).join('')}</div></div>
          <div><p class="ap-piece__label">Closure: <strong>${closureName(p.closure)}</strong></p><div class="ap-piece__opts ap-piece__opts--two">${closures.map((c) => `<button type="button" class="ap-piece__opt" data-piece="${i}" data-piece-closure="${c}" role="radio" aria-checked="${c === p.closure}" ${ok({ ...p, closure: c }) ? '' : 'disabled'}>${closureName(c)}</button>`).join('')}</div></div>
        </div>
      </details>`).join('');
    box.querySelectorAll('details').forEach((d) => d.addEventListener('toggle', () => {
      const i = Number(d.dataset.pieceCard);
      d.open ? state.open.add(i) : state.open.delete(i);
      d.querySelector('.ap-piece__edit').textContent = d.open ? 'Done' : 'Edit';
    }));
  }

  function items() {
    const rate = bundle().rate;
    const list = state.n === 1 ? [mainChoice()] : state.pieces;
    const map = new Map();
    list.forEach((p) => { const v = pieceVariant(p); if (v) map.set(v.id, (map.get(v.id) || 0) + 1); });
    let total = 0;
    map.forEach((q, id) => { total += unit(product.variants.find((v) => v.id === id), rate) * q; });
    return { items: [...map].map(([id, quantity]) => ({ id, quantity })), total };
  }

  function renderPrice() {
    const v = current();
    $('[data-ap-price-now]').textContent = fmt(v.price);
    const was = v.compare_at_price && v.compare_at_price > v.price ? v.compare_at_price : 0;
    $('[data-ap-price-was]').textContent = was ? fmt(was) : '';
    $('[data-ap-price-save]').textContent = was ? `Save ${Math.round((1 - v.price / was) * 100)}%` : '';
    const { total } = items();
    const add = $('[data-ap-add]');
    add.disabled = !v.available;
    $('[data-ap-add-label]').textContent = v.available ? (state.n > 1 ? `Add ${state.n} to cart` : 'Add to cart') : 'Sold out';
    $('[data-ap-add-price]').textContent = v.available ? fmt(total) : '';
    const sticky = document.querySelector('[data-ap-sticky]');
    if (sticky) {
      sticky.querySelector('[data-ap-sticky-price]').textContent = fmt(total);
      const same = state.n === 1 || state.pieces.every((p) => p.colour === state.pieces[0].colour && p.size === state.pieces[0].size && p.closure === state.pieces[0].closure);
      const first = state.n === 1 ? mainChoice() : state.pieces[0];
      sticky.querySelector('[data-ap-sticky-variant]').textContent = same
        ? `${state.n > 1 ? state.n + ' × ' : ''}${first.colour} · ${sizeName(first.size)} · ${isZip(first.closure) ? 'Zipper' : 'Envelope'}`
        : `${state.n} pillowcases · your own mix`;
    }
    if (history.replaceState && v) {
      const url = new URL(location.href); url.searchParams.set('variant', v.id);
      history.replaceState(history.state, '', url.toString());
    }
  }

  /* Keep the chosen combination valid when an option changes */
  function settle() {
    if (current() && current().available) return;
    const fallback = product.variants.find((v) => v.options[iColour] === state.colour && v.available);
    if (fallback) { state.size = fallback.options[iSize]; state.closure = fallback.options[iClosure]; }
  }

  root.addEventListener('click', (e) => {
    const t = e.target.closest('button');
    if (!t || t.disabled) return;
    if (t.dataset.piece !== undefined) {
      const p = state.pieces[Number(t.dataset.piece)];
      if (t.dataset.pieceColour) p.colour = t.dataset.pieceColour;
      if (t.dataset.pieceSize) p.size = t.dataset.pieceSize;
      if (t.dataset.pieceClosure) p.closure = t.dataset.pieceClosure;
      renderPieces(); renderPrice(); return;
    }
    if (t.dataset.colour) { state.colour = t.dataset.colour; settle(); syncPieces(true); renderOptions(); return; }
    if (t.dataset.size) { state.size = t.dataset.size; settle(); syncPieces(true); renderOptions(); return; }
    if (t.dataset.closure) { state.closure = t.dataset.closure; settle(); syncPieces(true); renderOptions(); return; }
    if (t.dataset.n) { state.n = Number(t.dataset.n); syncPieces(false); [...state.open].forEach((i) => { if (i >= state.n) state.open.delete(i); }); renderOptions(); return; }
    if (t.dataset.apOpen) { const d = root.querySelector(`[data-ap-dialog="${t.dataset.apOpen}"]`); d && d.showModal(); return; }
    if (t.hasAttribute('data-ap-close')) { t.closest('dialog').close(); return; }
    if (t.hasAttribute('data-ap-add')) addToCart();
  });
  root.querySelectorAll('dialog').forEach((d) => d.addEventListener('click', (e) => { if (e.target === d) d.close(); }));

  async function addToCart() {
    const btn = $('[data-ap-add]'), error = $('[data-ap-error]');
    const payload = items();
    btn.setAttribute('aria-busy', 'true'); error.hidden = true;
    $('[data-ap-add-label]').textContent = 'Adding…';
    try {
      const res = await fetch(`${root.dataset.cartAddUrl || '/cart/add'}.js`, {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: payload.items })
      });
      const data = await res.json();
      if (!res.ok || data.status) throw new Error(data.description || data.message || 'Could not add to cart');
      window.location.href = root.dataset.cartUrl || '/cart';
    } catch (err) {
      error.textContent = err.message || 'Something went wrong. Please try again.';
      error.hidden = false;
      btn.removeAttribute('aria-busy');
      renderPrice();
    }
  }

  /* ---------- Delivery estimate ---------- */
  (function delivery() {
    if (root.dataset.country !== 'CA') return;
    const add = (days) => { const d = new Date(); let n = 0; while (n < days) { d.setDate(d.getDate() + 1); if (d.getDay() % 6) n++; } return d; };
    const f = new Intl.DateTimeFormat('en-US', { weekday: 'short', month: 'short', day: 'numeric' });
    $('[data-ap-delivery-text]').innerHTML = `Free shipping · Get it <strong>${f.format(add(4))} – ${f.format(add(7))}</strong>`;
  })();

  /* ---------- Sticky bar ---------- */
  const sticky = document.querySelector('[data-ap-sticky]');
  if (sticky && 'IntersectionObserver' in window) {
    const cta = $('[data-ap-add]');
    let pastCta = false, atEnd = false;
    const update = () => {
      const show = pastCta && !atEnd;
      sticky.classList.toggle('is-visible', show);
      sticky.setAttribute('aria-hidden', String(!show));
      sticky.querySelector('button').tabIndex = show ? 0 : -1;
    };
    new IntersectionObserver(([e]) => { pastCta = !e.isIntersecting && e.boundingClientRect.top < 0; update(); }).observe(cta);
    const final = document.querySelector('.ap-final');
    if (final) new IntersectionObserver(([e]) => { atEnd = e.isIntersecting; update(); }).observe(final);
    sticky.querySelector('button').addEventListener('click', addToCart);
  }

  syncPieces(true);
  renderOptions();
})();
